/**
 * Конфигурация для thinking messages (сообщений "думает")
 */

export const THINKING_CONFIG = {
  // Таймаут для thinking messages в миллисекундах
  // Увеличен до 15 минут (900000 мс) для долгих операций
  DEFAULT_TIMEOUT: 900000,

  // Минимальный таймаут (30 секунд)
  MIN_TIMEOUT: 30000,

  // Максимальный таймаут (30 минут)
  MAX_TIMEOUT: 1800000,

  // Интервал проверки устаревших сообщений (30 секунд)
  CLEANUP_INTERVAL: 30000,

  // Дополнительное время для продления (5 минут)
  EXTEND_TIME: 300000,

  // Автоматическое продление при приближении к таймауту (за 2 минуты до истечения)
  AUTO_EXTEND_THRESHOLD: 120000,
  // Сообщения
  MESSAGES: {
    TIMEOUT: '⏳ Запрос обрабатывается дольше обычного. Система продолжает ожидание ответа от сервера...',
    AGENT_TIMEOUT: '⏳ Обработка запроса занимает больше времени. Агент продолжает работу, дождитесь ответа...',
    DEFAULT_THINKING: '🤔 Думаю...',
    AGENT_THINKING: '🤔 Агент работает...',
    EXTENDED_THINKING: '⏳ Обработка занимает больше времени, ожидаю ответ...',
    LONG_OPERATION: '🔄 Выполняется сложная операция, это может занять некоторое время...',
  },
};

export default THINKING_CONFIG;
